module.exports = __webpack_public_path__ + "img/1697118874360.d59977ad.jpg";